export default class Contract {
    // 获取合同
    static getContractList (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaContract/list', 'post', data, axiosOption, httpOption);
    }
    // 获取全部项目
    static getProjectAll (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaProject/list', 'post', data, axiosOption, httpOption);
    }
    // 获取全部项目
    static getProjectAllList (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaProject/projectList', 'post', data, axiosOption, httpOption);
  }
  // 付款审批单获取金额 
    static getProjectAmount(sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaPayApproval/projectAmount', 'post', data, axiosOption, httpOption);
  }
  // 获取请假天数
  static getQJdays(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/getQjDays', 'get', data, axiosOption, httpOption);
  }
  }